import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";

import { distributionUrlApiResponseSchema } from "../types/workerDocument.types";

const documentServiceRestApiUrl = environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL;

export async function fetchDocumentDistributionUrl(params: {
  documentId: string;
}): Promise<string> {
  const { documentId } = params;

  const response = await get({
    url: `${documentServiceRestApiUrl}/documents/${documentId}/distribution-url`,
    responseSchema: distributionUrlApiResponseSchema,
  });
  return response.data.data.attributes.distributionUrl;
}
